import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {UIGameManager} from '../UIGameManager'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {PIXI} from '@colonist/pixi'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameDiceView} from './UIGameDiceView'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {UIGameGoToPointAnimation} from '../../ui_canvas_engine/animation/UIGameGoToPointAnimation'
import {TimeoutId} from '@colonist/types'

export class UIGameDiceNumberAnimationController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private totalDiceNumberView: SpriteView | undefined
    private diceNumberViewDestroyTimeout: TimeoutId | undefined
    private diceNumberAnimation?: UIGameGoToPointAnimation

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        this.revealCurrentActionButtonOnReconnect()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.DiceStateUpdated: this.onDiceStateUpdated(); break
            default: break
        }
    }

    startDiceNumberAnimation(diceView: UIGameDiceView, waitMS: number) {
        this.diceNumberAnimation?.stop()
        const totalDiceNumber = this.uiGameManager.gameController.diceState.dice1 + this.uiGameManager.gameController.diceState.dice2
        const probabilityTexture = UIGameSpriteHandler.getProbabilityImage(totalDiceNumber)
        if(probabilityTexture == undefined) return

        this.totalDiceNumberView?.destroy()
        this.totalDiceNumberView = this.drawTotalDiceNumberView(probabilityTexture, diceView)

        const riseAnimationCompletionPointY = this.totalDiceNumberView.y - diceView.height
        const riseAnimationCompletionPoint = new PIXI.Point(this.totalDiceNumberView.x, riseAnimationCompletionPointY)

        const onRiseComplete = () => setTimeout(() => this.uiGameManager.eventController.sendEvent(totalDiceNumber, UIGameEventEnums.DiceNumberAnimationEnd), waitMS)

        this.diceNumberAnimation = new UIGameGoToPointAnimation(this.totalDiceNumberView, riseAnimationCompletionPoint)
        this.diceNumberAnimation.setOnStopCallback(() => setTimeout(onRiseComplete, waitMS))
        this.diceNumberAnimation.start()

        const autoDestroyWaitMS = waitMS * 10
        this.diceNumberViewDestroyTimeout = setTimeout(() => this.destroyTotalDiceNumberView(), autoDestroyWaitMS)
    }

    private destroyTotalDiceNumberView() {
        this.diceNumberAnimation?.stop()
        this.totalDiceNumberView?.destroy()
        this.totalDiceNumberView = undefined
        clearTimeout(this.diceNumberViewDestroyTimeout)
    }

    // eslint-disable-next-line class-methods-use-this
    private drawTotalDiceNumberView(probabilityTexture: PIXI.Texture, diceView: UIGameDiceView): SpriteView {
        const width = diceView.width * 0.4
        const height = width * (probabilityTexture.height / probabilityTexture.width)
        const totalDiceNumberView = new SpriteView(0, 0, width, height, diceView, probabilityTexture)
        totalDiceNumberView.centerXInParent()
        return totalDiceNumberView
    }

    private revealCurrentActionButtonOnReconnect() {
        if(!this.uiGameManager.gameController.diceState.diceThrown) return
        setTimeout(() => this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.CardAnimationEnd), 500)
    }

    private onDiceStateUpdated() {
        if(this.uiGameManager.gameController.diceState.diceThrown) return
        if(this.totalDiceNumberView == undefined) return
        this.destroyTotalDiceNumberView()
    }
}
